// @ts-strict-ignore
export enum FeatureToggle {
  PlatformOnly = 'rt_platform_only',
  ultrafastCrossDayDeliveryEnabled = 'rt_ultrafast_cross_day_delivery_enabled',
  shiftManagementStabilityM2 = 'rt_shift_management_stability_m2',
  bsmInIppEnable = 'rt_bulk_shifts_management_in_ipp_enabled',
}
